import Chart from 'bizcharts/lib/components/Chart'
import Axis from 'bizcharts/lib/components/Axis'
import Legend from 'bizcharts/lib/components/Legend'
import Tooltip from 'bizcharts/lib/components/Tooltip'
import Interval from 'bizcharts/lib/geometry/Interval'

import useLocale from '@/utils/useLocale'
import { Spin } from '@arco-design/web-react'
import Mask from '../Mask'

function GroupHistogram({
  data,
  loading,
  blur,
  height = 400,
  yAlias
}: {
  data: any
  loading: any
  blur: boolean
  height?: number
  yAlias?: string
}) {
  const t = useLocale()
  let chartIns = null

  const formatData = []
  data?.forEach((trendItem) => {
    const cur = formatData.find((item) => item?.axis_x === trendItem?.axis_x)

    if (cur) {
      cur[trendItem.legend] = trendItem?.axis_y
    } else {
      formatData.push({
        axis_x: trendItem?.axis_x,
        [trendItem.legend]: trendItem?.axis_y
      })
    }
  })

  const dataAxisList = formatData.length > 0 ? Object.keys(formatData?.[0])?.filter((item) => item !== 'axis_x') : []
  const y = dataAxisList?.[0] || ''
  const z = dataAxisList?.[1] || ''
  const scale = {
    axis_y: {
      alias: yAlias || t['product.detail.alias'],
      tickCount: 7,
      tickInterval: 10
    }
  }

  const label = {
    style: {
      fontSize: 12,
      fill: '#888BA6'
    }
  }
  const legendMap = {}
  return (
    <Spin loading={loading} style={{ width: '100%' }}>
      <Mask isBlur={blur} hasBtn={blur}>
        <Chart
          height={height}
          padding="auto"
          appendPadding={[0, 0, 40, 0]}
          data={data}
          autoFit
          scale={scale}
          onGetG2Instance={(chart) => {
            chart.interaction('active-region', {
              start: [
                { trigger: 'plot:mousemove', action: 'active-region:show', arg: { style: { fill: '#F9F8FAFF' } } }
              ]
            })
            chartIns = chart
          }}
        >
          <Axis
            name="axis_y"
            title
            grid={{
              line: {
                type: 'line',
                style: {
                  stroke: '#F0F1F8',
                  lineWidth: 1,
                  lineDash: [6, 4]
                }
              }
            }}
          />
          <Axis
            name="axis_x"
            label={label}
            line={{
              style: {
                stroke: '#F0F1F8',
                lineWidth: 1,
                lineDash: [6, 4]
              }
            }}
          />
          <Interval
            adjust={[
              {
                type: 'dodge',
                marginRatio: 0
              }
            ]}
            color={['legend', ['#EB54ACE0', '#655AECE0']]}
            position="axis_x*axis_y"
          />
          <Legend
            custom={true}
            allowAllCanceled={true}
            items={[
              {
                name: y,
                value: y,
                marker: {
                  symbol: 'circle',
                  style: { fill: '#EB54ACE0', r: 5 }
                }
              },
              {
                name: z,
                value: z,
                marker: {
                  symbol: 'circle',
                  style: { fill: '#655AECE0', r: 5 }
                }
              }
            ]}
            onChange={(ev) => {
              const { item } = ev
              const { value } = item
              const checked = !item.unchecked
              legendMap[value] = checked
              chartIns.filter('legend', (val) => {
                return legendMap[val] !== false
              })
              chartIns.render(true)
            }}
          />
          <Tooltip shared />
        </Chart>
      </Mask>
    </Spin>
  )
}

export default GroupHistogram
